import { useDispatch } from "react-redux";
import { axiosInstance } from "../../Axios";
import { setLoading } from "./loader";
import sessionLogoutReducer from "./logout";
import { tokenConfig } from "./tokenReducer";

const setAffList = (data) => {
    return {
      type: "SAVE_AFF_LIST",
      payload: data,
    };
};

const setCommissionPayment = (data) => {
    return {
      type: "SAVE_COMMISSION_LIST",
      payload: data,
    };
};

const setAffDashboard = (data) => {
    

    return {
      type: "SAVE_AFF_DASHBOARD",
      payload: data,
    };
};

const initialState = {dashboard: {}, list:[], commission_payment:[]}
const affiliateReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SAVE_AFF_LIST":
            return {
                ...state,
                list: action.payload,
            };
        case "SAVE_COMMISSION_LIST":
            return {
                ...state,
                commission_payment: action.payload,
            };
        case "SAVE_AFF_DASHBOARD":
            return {
                ...state,
                dashboard: action.payload
            }
    
        default:
            return state;
    }
}

export const requestAffiliateApproval = (payload) => async (dispatch, getState) => {
    try {
        const idToken = await getState().ACCtoken;
        payload['idToken'] = idToken;
        const {data, status} = await axiosInstance.post("/affiliate/apply/", payload);
        if(status>399) throw(data)
        return data;
    } catch (error) {
        if (error.response && error.response?.detail === "invalid-auth-token") {
            dispatch(sessionLogoutReducer());
            return;
        }
        throw(error)
    }
}

export const getAffList = () => async (dispatch, getState) =>{
    try {
        const {data} = await axiosInstance.get("/affiliate/v2/code/list/", tokenConfig(getState));
        dispatch(setAffList(data));
    } catch (error) {
        if (error.response.data?.detail === 'invalid-auth-token') {
            dispatch(sessionLogoutReducer());
            return;
        }
    }
}

export const getCommissionPayment = () => async (dispatch, getState) => {
    try {
        const {data} = await axiosInstance.get("/affiliate/v2/commission/payment/", tokenConfig(getState));
        dispatch(setCommissionPayment(data))

    } catch (error) {
        if (error.response && error.response?.detail === "invalid-auth-token") {
            dispatch(sessionLogoutReducer());
            return;
        }
    }
}

export const getAffDashboard = () => async (dispatch, getState) => {
    dispatch(setLoading(true))
    try {
        const {data} = await axiosInstance.get("/affiliate/v2/dashboard/", tokenConfig(getState));
        dispatch(setAffDashboard(data))
        dispatch(setLoading(false))

    } catch (error) {
        dispatch(setLoading(false))

        if (error.response && error.response?.detail === "invalid-auth-token") {
            dispatch(sessionLogoutReducer());
            return;
        }
    }
}

export default affiliateReducer;